import * as Progress from "@radix-ui/react-progress";
import { styled } from "@vitality-ds/system";
import BaseLinearProgressStyles from "./styles/BaseLinearProgress.styles";
import BaseLinearProgressIndicatorStyles from "./styles/BaseLinearProgressIndicator.styles";
export var BaseLinearProgress = styled(Progress.Root, BaseLinearProgressStyles);
export var BaseLinearProgressIndicator = styled(Progress.Root, BaseLinearProgressIndicatorStyles);